import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";

export default async function psReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const h2 = new TableReportHelper(apontamento);

        const isColetaAntiga = apontamento.coletas && apontamento.coletas.length > 0 && apontamento.coletas.filter(c => c.quantidade).length > 0
        const coletas = isColetaAntiga
            ? coletasTTP(visita, apontamento)
            : await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Tolete", "Conforme"],
                // prettier-ignore
                (h) => [
                    h.numberField("tolete"),
                    h.textField("conforme"),
                ],
                [60, 60]
            )

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                undefined,
                undefined,
                {
                    label: "Operador",
                    field: "operador.operador",
                    width: "*"
                }
            ),
            h.panel(
                [
                    h.row(
                        h.title("Localização"),
                        h.title("Insumo"),
                        h.title("Variedade"),
                        h.title("Qtd. Toletes Picados")
                    ),

                    h.row(

                        h2.locationField("georeferencia"),
                        h2.textField("insumo.nomeInsumo"),
                        h2.textField("variedade.nomeInsumo"),
                        h2.textField("totalToletes")
                    ),
                ],
                { widths: [110, "*", "*", 110] }
            ),
            coletas,
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}

function coletasTTP(visita, apontamento) {
    const h = new TableReportHelper(apontamento);

    let content = []
    content.push(h.row(
        h.title("Coletas", { colSpan: 3 })
    ))
    content.push(h.row(
        h.title("Classificação"),
        h.title("Qtd. Tolete"),
        h.title("%")
    ))
    apontamento.coletas?.forEach(c => {
        content.push(h.row(
            h.text(c.classificacaoStr),
            h.text(c.quantidade),
            h.text(c.percentual)
        ))
    });

    return h.panel(content,
        { widths: ["*", 110, 110] }
    )
}